"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLayout = AppLayout;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var sidebar_1 = require("./sidebar");
var header_1 = require("./header");
function AppLayout() {
    var _a = (0, react_1.useState)(false), sidebarOpen = _a[0], setSidebarOpen = _a[1];
    var toggleSidebar = function () {
        setSidebarOpen(function (prev) { return !prev; });
    };
    var closeSidebar = function () {
        setSidebarOpen(false);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-screen overflow-hidden bg-background", children: [(0, jsx_runtime_1.jsx)(sidebar_1.Sidebar, { isOpen: sidebarOpen, onClose: closeSidebar }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-1 flex-col overflow-hidden", children: [(0, jsx_runtime_1.jsx)(header_1.Header, { onMenuClick: toggleSidebar }), (0, jsx_runtime_1.jsx)("main", { className: "flex-1 overflow-y-auto p-4 lg:p-6", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) })] })] }));
}
